module.exports = __webpack_public_path__ + "static/media/csv_file.685ac24a.svg";